// src/composables/useDateFormatter.js
import { computed } from 'vue';

export const useDateFormatter = (dateRef) => {
  const formatDateTime = (dateString, options = {}) => {
    try {
      const date = new Date(dateString);
      if (isNaN(date)) return "";
      
      const defaultOptions = {
        year: 'numeric',
        month: 'long',
        day: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
        timeZone: 'UTC'
      };

      return date.toLocaleDateString("es-ES", {...defaultOptions, ...options});
    } catch (error) {
      console.error("Error formateando fecha:", error);
      return "";
    }
  };

  const formattedDate = computed(() => {
    try {
      const date = new Date(dateRef.value);
      if (isNaN(date)) return { weekday: "", day: "" };

      return {
        weekday: date.toLocaleDateString("es-ES", { weekday: "long" })
                    .replace(/^\w/, c => c.toUpperCase()),
        day: date.getDate(),
        fullDate: formatDateTime(date)
      };
    } catch (error) {
      console.error("Error formateando fecha:", error);
      return { weekday: "", day: "" };
    }
  });

  const formatToISO = (date) => date.toISOString().split("T")[0];

  return {
    formattedDate,
    formatToISO,
    formatDateTime
  };
};